import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class announcement_template extends vnTemplate{

    protected getTemplateHtml(): string{
        return `
             <p class="text">Freelancer Payment Scheduling Announcement</p>
            
            <p class="text">Currently, Valnet Inc. (“Valnet”) payments for freelancers are made on the first business day following, the 15th or last day of the month, and include all work provided or published in that period. This very tight payment schedule is very restrictive, limits Valnet’s ability to validate transactions, often results in payment mistakes or errors, and greatly limits Valnet’s capacity to react to unforeseen circumstances.</p>
            
            <p class="text">Valnet does not currently intend to make any changes to the current payment schedule, however, Valnet reserves the right to allow for a reconciliation period prior to processing upcoming payments. In the event this should be required, an adjusted time frame could be introduced where payments are deliverable up to 15 to 30 days after work was provided (e.g. the publishing of an article). The exact date when payments are delivered would remain the same.</p>
            
            <p class="text">Please note that no changes are planned at this time. You can expect to be notified in advance if any changes are to be made</p>
        `;

    }

    protected getTemplateName(): string{
        return "announcement-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected buildViewModel(): any{

        let huit_neuf_this = this;
        return  {  };
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/announcement_template.ts